module.exports = __webpack_public_path__ + "img/4.d7be6766.jpg";